import React from 'react';
import type { Workspace } from '@/types';
import type { ProfileData } from './types';

interface IdentityHeaderProps {
  profile: ProfileData;
  roleColor: string;
  currentWorkspace: Workspace | null;
}

const IdentityHeader: React.FC<IdentityHeaderProps> = ({ profile, roleColor, currentWorkspace }) => (
  <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm sm:p-8 dark:border-gray-700 dark:bg-gray-800">
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2.5">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{profile.name}</h1>
          <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ring-1 ring-inset ${roleColor}`}>
            <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
              <path fillRule="evenodd" d="M16.7 6.3a1 1 0 010 1.4l-7 7a1 1 0 01-1.4 0l-3-3a1 1 0 111.4-1.4L9 12.6l6.3-6.3a1 1 0 011.4 0z" clipRule="evenodd" />
            </svg>
            {profile.role}
          </span>
        </div>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{profile.email}</p>
      </div>
      {currentWorkspace && (
        <div className="shrink-0 rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 dark:border-gray-700 dark:bg-gray-900/40">
          <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">Active workspace</p>
          <p className="mt-0.5 text-sm font-semibold text-gray-900 dark:text-gray-100">{currentWorkspace.name}</p>
        </div>
      )}
    </div>
  </div>
);

export default IdentityHeader;
